import React, { useMemo } from 'react'
import { CardSwiper } from '../../../CardSwiper'
import { CategoryView } from './CategoryView'
import { Box } from '../../../Layout'
import { Head2 } from 'Components/Typography/Text.styles'
import { FeedCategoryItem } from 'Api/Feed/feed.types'

type VideoCategoriesProps = {
  categories: FeedCategoryItem[]
  categorySectionTitle?: string
}

export const VideoCategories: React.FC<React.PropsWithChildren<VideoCategoriesProps>> = ({
  categories,
  categorySectionTitle,
}) => {
  const items = useMemo(() => {
    return categories.map((category) => (
      <CategoryView key={category.tags} category={category} />
    ))
  }, [categories])
  if (!categories?.length) return null

  return (
    <Box>
      {categorySectionTitle && <Head2>{categorySectionTitle}</Head2>}
      <CardSwiper items={items} cardSize="videoCategories" />
    </Box>
  )
}
